import { styled, css, useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { getStyleProp } from '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Button, Span } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '../ClickOutside/ClickOutside.js';
import Tooltip from '../Tooltip/Tooltip.js';
import TileButton from '../TileButton/TileButton.js';

const _excluded = ["block", "disabled", "small", "large", "shape", "theme", "iconOnly"];
const ButtonTile = styled(Button).attrs(_ref => {
  let {
      block,
      disabled,
      small,
      large,
      shape,
      theme,
      iconOnly
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2(_objectSpread2({}, theme.typography.button), {}, {
    position: 'relative',
    display: block ? 'flex' : 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '116px',
    height: '116px',
    borderColor: theme.palette.primary.main,
    outline: 'none',
    userSelect: 'none',
    zIndex: 1,
    fontSize: small ? theme.typography.pxToRem(13) : large ? theme.typography.pxToRem(15) : theme.typography.button.fontSize,
    p: small ? iconOnly ? `${theme.spacing.sm}px ${theme.spacing.sm}px` : `${theme.spacing.xs}px ${theme.spacing.sm}px` : large ? iconOnly ? `${theme.spacing.lg}px ${theme.spacing.lg}px` : `${theme.spacing.md}px ${theme.spacing.lg}px` : iconOnly ? `${theme.spacing.md}px ${theme.spacing.md}px` : `${theme.spacing.sm}px ${theme.spacing.md}px`,
    borderRadius: shape === 'circle' ? '50%' : '2px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    bg: theme.palette.common.white
  }, rest);
})`
  ${({
  pointerEvents
}) => css`
    pointer-events: ${pointerEvents};
  `}
  white-space: nowrap;
  overflow: hidden;
  transition: all 0.2s;

  &:hover {
    background-color: ${({
  theme
}) => theme.palette.grey[20]};
  }
  &:focus {
    background-color: ${({
  theme
}) => theme.palette.grey[40]};
  }
`;

const _excluded$1 = ["type", "shape", "onClick", "textCenter", "children", "iconProps", "frontComponent", "styles", "toolTip"];
function ButtonTile$1(_ref) {
  let {
      type = 'button',
      shape = 'default',
      onClick,
      textCenter,
      children,
      iconProps,
      frontComponent,
      styles = {},
      toolTip
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  const theme = useTheme();
  const handleClick = event => {
    if (onClick) {
      onClick(event);
    }
  };
  /* Assign commandbar tooltipProps to button tooltip - start */
  if (props !== null && props !== void 0 && props.tooltipProps) {
    var _props$tooltipProps, _props$tooltipProps2;
    toolTip = _objectSpread2(_objectSpread2({}, props), {}, {
      message: props === null || props === void 0 ? void 0 : (_props$tooltipProps = props.tooltipProps) === null || _props$tooltipProps === void 0 ? void 0 : _props$tooltipProps.message,
      placement: props === null || props === void 0 ? void 0 : (_props$tooltipProps2 = props.tooltipProps) === null || _props$tooltipProps2 === void 0 ? void 0 : _props$tooltipProps2.placement
    });
  }
  /* Assign commandbar tooltipProps to button tooltip - end */
  let otherProps = _objectSpread2({
    type,
    iconOnly: !children && !!iconProps,
    shape
  }, props);
  const getStyles = key => {
    return getStyleProp(key, styles, theme);
  };
  const cursorProp = props !== null && props !== void 0 && props.disabled ? 'not-allowed' : 'pointer';
  const pointerEvents = props !== null && props !== void 0 && props.disabled && toolTip ? 'none' : 'auto';
  const tootTipDisplay = props.block ? 'flex' : 'inline-flex';
  const getButton = () => {
    otherProps = _objectSpread2(_objectSpread2({}, otherProps), {}, {
      cursor: cursorProp,
      pointerEvents
    });
    return /*#__PURE__*/createElement(ButtonTile, _extends({
      onClick: handleClick
    }, otherProps, getStyles('root')), /*#__PURE__*/createElement(TileButton, {
      title: children === null || children === void 0 ? void 0 : children.toString(),
      icon: {
        glyph: iconProps === null || iconProps === void 0 ? void 0 : iconProps.glyph
      },
      isDisabled: props.disabled,
      styles: {
        root: {
          borderWidth: 0,
          hoverBorderColor: theme.palette.grey[20],
          hoverBoxShadow: theme.palette.grey[20],
          fontSize: theme.typography.pxToRem(16),
          fontFamily: theme.typography.fontFamily,
          fontWeight: theme.typography.fontWeightBold
        }
      }
    }));
  };
  if (toolTip) {
    var _toolTip, _toolTip2, _toolTip3;
    return /*#__PURE__*/createElement(Tooltip, {
      styles: {
        root: {
          width: '100%'
        }
      },
      message: (_toolTip = toolTip) === null || _toolTip === void 0 ? void 0 : _toolTip.message,
      placement: (_toolTip2 = toolTip) === null || _toolTip2 === void 0 ? void 0 : _toolTip2.placement,
      disableToolTip: ((_toolTip3 = toolTip) === null || _toolTip3 === void 0 ? void 0 : _toolTip3.message) === undefined
    }, /*#__PURE__*/createElement(Span, {
      style: {
        cursor: cursorProp,
        display: tootTipDisplay
      }
    }, getButton()));
  }
  return getButton();
}

export default ButtonTile$1;
